var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMutedAudio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#4B9BF5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.9121 24.3558C30.9121 23.9238 30.5818 23.5934 30.1498 23.5934C29.7178 23.5934 29.3874 23.9238 29.3874 24.3558C29.3874 27.3289 26.9733 29.7431 24.0001 29.7431C21.027 29.7431 18.6128 27.3289 18.6128 24.3558C18.6128 23.9238 18.2825 23.5934 17.8505 23.5934C17.4185 23.5934 17.0881 23.9238 17.0881 24.3558C17.0881 27.888 19.731 30.8612 23.2378 31.2424V33.2753H20.4679C20.0359 33.2753 19.7055 33.6057 19.7055 34.0377C19.7055 34.4697 20.0359 34.8 20.4679 34.8H27.5324C27.9644 34.8 28.2947 34.4697 28.2947 34.0377C28.2947 33.6057 27.9644 33.2753 27.5324 33.2753H24.7625V31.2424C28.2693 30.8612 30.9121 27.888 30.9121 24.3558Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0004 13.2C21.6625 13.2 19.7566 15.1059 19.7566 17.4438V24.3304C19.7566 26.6937 21.6625 28.5741 24.0004 28.5995C26.3382 28.5995 28.2441 26.6937 28.2441 24.3558V17.4438C28.2441 15.1059 26.3382 13.2 24.0004 13.2Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.6,
    height: 21.6,
    fill: "white",
    transform: "translate(13.2 13.2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMutedAudio);
export default __webpack_public_path__ + "static/media/muted_audio.a342ea27c78cb5a3f48517ac4c028926.svg";
export { ForwardRef as ReactComponent };